import { MOTION_DEFINITION, createPresenceComponent } from './createPresenceComponent';
/**
 * @internal
 */ export function overridePresenceMotion(presenceMotion, override) {
    return (...args)=>{
        const { enter, exit } = presenceMotion(...args);
        return {
            enter: {
                ...enter,
                ...override.all,
                ...override.enter
            },
            exit: {
                ...exit,
                ...override.all,
                ...override.exit
            }
        };
    };
}
export function createPresenceComponentVariant(component, override) {
    return createPresenceComponent(overridePresenceMotion(component[MOTION_DEFINITION], override));
}
